/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Client, ContactInfoTypeEnum } from '@truckstop-tms/zuum-lib';

export class ContactInfo {
  constructor(
    public type: ContactInfoTypeEnum,
    public email = '',
    public phoneNo = '',
    public phoneNumberExt = '',
    public cellNo = '',
    public fullName = '',
    public client?: Client,
    public clientId?: number,
    public id?: number,
    public companyId?: string,
    public companyLogo?: string,
    public companyName?: string,
    public street?: string,
    public city?: string,
    public state?: string,
    public zip?: string
  ) {}
}
